import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../../Layouts/ButtonsControlled";
import { FormHeading } from "../../../Layouts/Heading";
import {
    designersReset,
    GetAllDesigners,
} from "../../../Redux/DesignerSlice/DesignerSlice";
import {
    CreateLicens,
    licensReset,
    UpdateSingleLicens,
} from "../../../Redux/DesignerSlice/LicensSlice/LicensSlice";
import { getAllState, resetState } from "../../../Redux/StateSlice/stateSlice";

const CreateLicense = () => {
    const { isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.designer_licens
    );
    const dispatch = useDispatch();

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, [dispatch]);

    const { designers } = useSelector((state) => state.designers);
    const AllDesigners = designers?.data || [];
    // get all Designers
    useEffect(() => {
        const getAllDesigners = async () => {
            await dispatch(GetAllDesigners());
            await dispatch(designersReset());
        };
        getAllDesigners();
    }, [dispatch]);

    const { states } = useSelector((state) => state.AllStates);

    //get All States
    const AllStates = states?.data?.states;
    const formik = useFormik({
        initialValues: {
            holder_name: "",
            license_number: "",
            state_id: "",
            designer_id: "",
        },
        onSubmit: async (values) => {
            await dispatch(CreateLicens(values));
            await dispatch(licensReset());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(licensReset());
            };
            reset();
        }
        if (isSuccess) {
            toast.success("The data has been modified successfully");
            formik.values.holder_name = "";
            formik.values.license_number = "";
            formik.values.state_id = "";
            formik.values.designer_id = "";
        }
    }, [isError, errors, dispatch, isSuccess, formik]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    <FormHeading> Create License </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item mb={2} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="holder_name"
                                    name="holder_name"
                                    label="Holder Name"
                                    value={formik.values.holder_name}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={2} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="license_number"
                                    name="license_number"
                                    label="License Number"
                                    value={formik.values.license_number}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="state_id"
                                        name="state_id"
                                        label="State"
                                        required={true}
                                        value={formik.values.state_id}
                                        onChange={formik.handleChange}
                                    >
                                        {AllStates?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        Designer
                                    </InputLabel>
                                    <Select
                                        id="designer_id"
                                        name="designer_id"
                                        label="Designer"
                                        required={true}
                                        value={formik.values.designer_id}
                                        onChange={formik.handleChange}
                                    >
                                        {AllDesigners?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "Loading..." : "Create"}
                        </PrimaryButton>
                    </form>
                </>
            )}
        </>
    );
};

export default CreateLicense;
